import { useRef } from 'react';
import { Button } from '#components/atoms/buttons/Button.tsx';
import { RemoteAllowListForm } from '#components/patterns/config-overrides/forms/RemoteAllowForm.tsx';
import { ConfirmButtonGroup } from '#components/patterns/confirmations/confirm-button-group/ConfirmButtonGroup.tsx';
import { Modal, ModalBody, ModalFooter, ModalHeader } from '#components/patterns/modal/index.ts';
import type { CIDRRule } from '#dn-types/config-override.ts';

type Props = {
  onCancel: () => void;
  onSave: (values: CIDRRule) => void;
  value?: CIDRRule;
  cidrValidation: (value: string) => string | true;
};

export function RemoteAllowModal({ onSave, onCancel, cidrValidation, value }: Props) {
  const modalRef = useRef(null);

  return (
    <Modal isOpen={true} onClose={onCancel} ref={modalRef}>
      <ModalHeader>{value ? 'Change remote allow row' : 'Add to remote allow list'}</ModalHeader>
      <ModalBody>
        <RemoteAllowListForm defaultValues={value} onSave={onSave} cidrValidation={cidrValidation} />
      </ModalBody>
      <ModalFooter>
        <ConfirmButtonGroup
          variant="right"
          primaryButton={
            <Button type="submit" form="lighthouse.remote_allow_list-form">
              {value ? 'Save' : 'Add'}
            </Button>
          }
          secondaryButton={
            <Button variant="link" onClick={onCancel}>
              Cancel
            </Button>
          }
        />
      </ModalFooter>
    </Modal>
  );
}
